export default __webpack_public_path__ + "population-800-8e5871295ee4f5fd764d3b63b9252ad1.png";